module.exports = __webpack_public_path__ + "img/vehicle_types.c0debc28.png";